<template>
  <v-row>
    <v-col cols="12" class="text-h5 font-weight-regular pb-0">{{ funcao }}</v-col>
    <v-col class="pt-0">
      <v-chip
        v-for="(profissional) in profissionais"
        :key="profissional.id"
        class="ma-1"
      >{{ profissional.nome }}</v-chip>
    </v-col>
  </v-row>
</template>
<script>
export default {
  name: 'ProfissionaisPorFuncaoComponent',
  props: {
    funcao: {
      type: String,
      required: true
    },
    profissionais: {
      type: Array,
      required: true
    }
  },
}

</script>